import Stack from '~/common/components/Stacks/Stack';
import DrawerBody from '~/common/mui/Drawers/DrawerBody';
import DrawerContent from '~/common/mui/Drawers/DrawerContent';
import type { HistoricalCalculation } from '~/pages/IncomeCalculator/CalculationHistory/types';

import { CalculationTypes, REQUEST_REFERENCE_TYPE } from '../enums';
import CalculationCard from './CalculationCard';
import HistoricalBreakdown from './HistoricalBreakdown';
import PreviousEmploymentBreakdown from './HistoricalBreakdown/PreviousEmploymentBreakdown';
import HistoryDrawerHeader from './HistoryDrawerHeader';

const previousEmploymentCalculationTypes: Set<number> = new Set([
  CalculationTypes.QualifyingPaystub,
  CalculationTypes.QualifyingVoe,
  CalculationTypes.QualifyingYearEndPaystub,
]);

type HistoryDrawerProps = {
  data?: HistoricalCalculation[];
  selectedCalculation?: HistoricalCalculation;
  setSelectedCalculation: (...args: any[]) => any;
};

const HistoryDrawer = ({
  data,
  selectedCalculation,
  setSelectedCalculation,
}: Readonly<HistoryDrawerProps>) => {
  const onSelectSummary = (summary) => {
    setSelectedCalculation(summary);
  };

  const { calculationId, calculatorTypeId, calculationAuditId } =
    selectedCalculation || {};

  const onNewWindow = () => {};

  const closeCalculation = () => {
    setSelectedCalculation(null);
  };

  const renderedHistoricalBreakdown = previousEmploymentCalculationTypes.has(
    calculatorTypeId,
  ) ? (
    <PreviousEmploymentBreakdown calculationId={calculationId} />
  ) : (
    <HistoricalBreakdown
      calculationId={calculationId}
      calculationAuditId={calculationAuditId}
      onNewWindow={onNewWindow}
    />
  );

  if (calculationId) {
    const isRental =
      selectedCalculation.requestReferenceType ===
      REQUEST_REFERENCE_TYPE.rentalIncome;
    const selectedCalculationSummary = data.find((summary) =>
      isRental
        ? summary.calculationId === calculationId
        : summary.calculationAuditId === calculationAuditId,
    );

    return (
      <DrawerContent>
        <HistoryDrawerHeader
          calculationInformation={selectedCalculationSummary}
          onClose={closeCalculation}
          haveSelectedACalculation={true}
        />
        <DrawerBody>{renderedHistoricalBreakdown}</DrawerBody>
      </DrawerContent>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <DrawerContent>
      <HistoryDrawerHeader calculationInformation={data[0]} />
      <DrawerBody>
        <Stack spacing={4}>
          {data.map((summary) => (
            <CalculationCard
              summary={summary}
              onClick={() => onSelectSummary(summary)}
              key={summary.calculationAuditId}
            />
          ))}
        </Stack>
      </DrawerBody>
    </DrawerContent>
  );
};

export default HistoryDrawer;
